module.exports = __webpack_public_path__ + "static/media/customRPCHint.58196683.png";